import { toErrorInfo } from '@csp/csp-common-model';
import { CopyResult } from '../model/CopyResult';

const writeToClipboard = async (text: string): Promise<void> => navigator.clipboard.writeText(text);

const writeToClipboardWithResult = async (text: string): Promise<CopyResult> => {
  try {
    await navigator.clipboard.writeText(text);
    return {
      status: 'success',
    };
  } catch (error) {
    return {
      status: 'error',
      error: toErrorInfo({ error }),
    };
  }
};

export const CopyUtil = {
  writeToClipboard,
  writeToClipboardWithResult,
};
